<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_resubscribepin_you_are_close }}</h1>
          <img class="modal_icon_alert" src="static/images/modals/resubscribe_success.png" />
          <p>{{ getTranslations.home_modals_resubscribepin_we_sent }}</p>
          <form action="">
            <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
              <input type="text" class="form-group__textfield phone_input" :placeholder="getTranslations.home_modals_resubscribepin_enter_the" @keyup="check" v-model="pin"/>
              <span v-show="message && pin && hasErrors" class="form-group__feedback">{{ message }}</span>
            </div>
            <input @click.prevent="sendPin" type="submit" :value="getTranslations.home_modals_resubscribepin_confirm" class="ti_btn--main" :class="[ !hasErrors ? '' : 'deactivated' ]"><!--ADD CLASS "deactivated" IF "has-warning" IS ACTIVE AS WELL ABOVE-->
          </form>
         <span class="terms">{{ getTranslations.home_modals_resubscribepin_by_clicking_resubscribe }}<br> <span class="make_it_bold"><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">{{ getTranslations.home_modals_resubscribepin_terms_and_conditions }}</a></span>{{ getTranslations.home_modals_resubscribepin_of_service }} </span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';

export default {
  // modal_resubscribe_pin.html
  name: 'resubscribe-via-pin',
  data() {
    return {
      nextPage: '',
      pin: '',
      message: '',
      hasErrors: false,
    };
  },
  components: {
    WelcomeReturningUnsub,
  },
  methods: {
    ...mapActions('profile', [
      'sendReOptinPin',
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
      'storeModalForStore',
      'storeModalForHomePage',
    ]),
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    sendPin() {
      // eslint-disable-next-line
      console.log('Send Pin Method');
      this.message = '';
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        // eslint-disable-next-line
        console.log('Send Pin for Resubscribe user Call in 2 step');
        const pinParam = {
          pin: this.pin,
        };
        this.sendReOptinPin({ pinObject: pinParam }).then(() => {
          // eslint-disable-next-line
          console.log('Resubscribe user Call in 2 step Reoptin');
          if (this.twoStepVerificationVerified) {
            this.hasErrors = false;
            this.getUserLoginDetails().then(() => {
              if (sessionStorage.getItem('homeCurrentTabPath') === '/home' || sessionStorage.getItem('homeCurrentTabPath') === '/home/profile') {
                this.storeModalForHomePage(WelcomeReturningUnsub);
                modals.showHideModalForHomeStorePage(this);
              } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
                this.storeModalForStore(WelcomeReturningUnsub);
                modals.showHideModalForHomeStorePage(this);
              } else {
                this.storeModalForSettings(WelcomeReturningUnsub);
                modals.showHideModalForHomePage(this);
              }
            });
          } else if (this.twoStepVerificationWrongPin) {
            this.hasErrors = true;
            this.message = this.getTranslations.home_modals_resubscribepin_oops;
          } else if (this.twoStepVerificationServerError) {
            if (sessionStorage.getItem('homeCurrentTabPath') === '/home/settings') {
              this.storeModalForSettings(null);
              modals.hideModal(this);
            } else {
              modals.hideModalForHomeStorePage(this);
            }
          }
        });
      } else {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'twoStepVerificationVerified',
      'twoStepVerificationWrongPin',
      'twoStepVerificationServerError',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeViaPin.vue